import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrganizations } from "../store/reducers/organizationSlice";
import { fetchRoles } from "../store/reducers/roleSlice";
import { Modal, Button } from "react-bootstrap";
import _ from "lodash";

const AdminPeron = () => {
  const page = 1;
  const itemsPerPage = 10;
  const [admin, setAdmin] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [organizationFilter, setOrganizationFilter] = useState("");
  const [roleFilter, setRoleFilter] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteUserId, setDeleteUserId] = useState(null);
  const [pendingFilterChange, setPendingFilterChange] = useState(false);
  const [nameFilter, setNameFilter] = useState("");
  const [debouncedName, setDebouncedName] = useState("");
  const jwtToken = localStorage.getItem("jwt_token");
  const history = useHistory();
  const dispatch = useDispatch();
  const { organizations } = useSelector((state) => state.organization);
  const { roles } = useSelector((state) => state.role);

  const DataPerson = async (page, orgId = "", user_role = "", name = "") => {
    setLoading(true);
    let url = `${process.env.REACT_APP_API_URL}/people?page=${page}&limit=${itemsPerPage}`;
    if (orgId) url += `&organisation_id=${orgId}`;
    if (user_role) url += `&user_role=${user_role.trim()}`;
    if (name) url += `&name=${encodeURIComponent(name.trim())}`;
    try {
      const res = await fetch(url, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      const data = await res.json();
      const codeMessage = data.data?.people_details;
      if (codeMessage) {
        setAdmin(codeMessage);
        setPageCount(Math.ceil(data.data.count / itemsPerPage));
      } else {
        toast.error("Something went wrong, Please try again later");
      }
    } catch (err) {
      toast.error("Error fetching data");
    }
    setLoading(false);
  };

  useEffect(() => {
    const handler = _.debounce((value) => {
      setDebouncedName(value);
    }, 500); // 500ms delay
    handler(nameFilter);
    return () => {
      handler.cancel();
    };
  }, [nameFilter]);

  useEffect(() => {
    if (pendingFilterChange) {
      setCurrentPage(1);
      setPendingFilterChange(false);
      DataPerson(1, organizationFilter, roleFilter, debouncedName);
    } else {
      DataPerson(currentPage, organizationFilter, roleFilter, debouncedName);
    }
    // eslint-disable-next-line
  }, [organizationFilter, roleFilter, debouncedName, currentPage]);

  useEffect(async () => {
    await dispatch(fetchOrganizations());
    await dispatch(fetchRoles());
  }, [dispatch]);

  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1;
    setCurrentPage(selectedPage);
  };
  const handleDeleteClick = (item) => {
    if (item.is_admin) {
      toast.error("You can't delete an admin user.");
      return;
    }
    setDeleteUserId(item.id);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    if (!deleteUserId) return;
    setLoading(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/delete-people-role/${deleteUserId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      if (res.ok) {
        toast.success("User deleted successfully");
        setShowDeleteModal(false);
        setDeleteUserId(null);
        DataPerson(currentPage, organizationFilter, roleFilter);
      } else {
      }
    } catch (err) {
      toast.error("Error deleting user");
    }
    setLoading(false);
  };

  const handleOrganizationFilterChange = (e) => {
    setOrganizationFilter(e.target.value);
    setPendingFilterChange(true);
  };

  const handleRoleFilterChange = (e) => {
    setRoleFilter(e.target.value);
    setPendingFilterChange(true);
  };

  const handleNameFilterChange = (e) => {
    setNameFilter(e.target.value);
    setPendingFilterChange(true);
  };

  return (
    <>
      <div className="row my-2 align-items-center">
        <div className="col-12 d-flex flex-column flex-md-row align-items-center justify-content-between">
          <div className="fw-bold mb-2 mb-md-0" style={{ minWidth: 120 }}>
            Admin Person
          </div>
          <div
            className="d-flex justify-content-center align-items-center gap-2 mx-auto"
            style={{ maxWidth: 800, width: "100%" }}
          >
            <input
              type="text"
              className="form-control w-auto"
              style={{ minWidth: 200 }}
              placeholder="Search by name"
              value={nameFilter}
              onChange={handleNameFilterChange}
            />
            <div className="d-flex align-items-center">
              <select
                className="form-control w-auto"
                style={{ minWidth: 200 }}
                value={organizationFilter}
                onChange={handleOrganizationFilterChange}
              >
                <option value="">Select Organisation</option>
                {organizations &&
                  organizations.map((org) => (
                    <option key={org.id} value={org.id}>
                      {org.name}
                    </option>
                  ))}
              </select>
              {organizationFilter && (
                <button
                  className="btn btn-sm btn-secondary ms-2"
                  type="button"
                  onClick={() => setOrganizationFilter("")}
                >
                  Clear
                </button>
              )}
            </div>
            <div className="d-flex align-items-center">
              <select
                className="form-control w-auto"
                style={{ minWidth: 200 }}
                value={roleFilter}
                onChange={handleRoleFilterChange}
              >
                <option value="">Select Role</option>
                {roles &&
                  roles.map((role) => (
                    <option key={role.id} value={role.type}>
                      {role.type}
                    </option>
                  ))}
              </select>
              {roleFilter && (
                <button
                  className="btn btn-sm btn-secondary ms-2"
                  type="button"
                  onClick={() => setRoleFilter("")}
                >
                  Clear
                </button>
              )}
            </div>
          </div>
          <Link
            to="/admin-person/add-person"
            className="ms-md-auto mt-2 mt-md-0"
          >
            <button className="btn bg_color" type="button">
              Add person
            </button>
          </Link>
        </div>
      </div>
      {loading ? (
        <div className="text-center" style={{ width: "100%" }}>
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">ID</th>
                <th scope="col">First Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">Phone number</th>
                <th scope="col">Organization(s) and role(s)</th>
                <th scope="col">Update</th>
                <th scope="col">Remove</th>
              </tr>
            </thead>
            <tbody>
              {admin.map((item, i) => {
                return (
                  <tr key={item.id}>
                    <th scope="row">
                      {i + 1 + itemsPerPage * (currentPage - 1)}
                    </th>
                    <td>{item.first_name}</td>
                    <td>{item.last_name}</td>
                    <td>{item.phone_number}</td>
                    <td style={{ marginLeft: "12px !impoartent" }}>
                      <i
                        type="button"
                        className="nav-icon fas fa-eye btn-lg bg_color "
                        onClick={() => {
                          history.push({
                            pathname: `/admin-person/adminpermission-list`,
                            search: `?id=${item.id}`,
                          });
                        }}
                      ></i>
                    </td>
                    <td>
                      <i
                        type="button"
                        className="nav-icon fas fa-edit btn btn-lg bg_color"
                        onClick={() => {
                          history.push({
                            pathname: `/admin-person/add-person`,
                            search: `?id=${item.id}`,
                          });
                        }}
                      ></i>
                    </td>
                    <td>
                      <button
                        className="btn btn-lg bg_color "
                        onClick={() => handleDeleteClick(item)}
                      >
                        <i className="nav-icon fas fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                );
              })}
              <tr hidden={admin.length !== 0}>
                <td colSpan="5" className="text-center">
                  Data Not Found
                </td>
              </tr>
            </tbody>
          </table>
        </>
      )}
      <ReactPaginate
        nextLabel="Next"
        onPageChange={handlePageClick}
        pageRangeDisplayed={10}
        pageCount={pageCount}
        forcePage={currentPage - 1}
        previousLabel="Previous"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link bg_color"
        containerClassName="pagination"
        activeClassName="active"
        renderOnZeroPageCount={null}
      />
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this user?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            No
          </Button>
          <Button variant="danger" onClick={handleConfirmDelete}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default AdminPeron;
